import React, { memo } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { IShipment } from 'types'
import { DISPLAY } from 'constants/display'
import { InlineRow } from '../../../components/load-details/InlineRow'
import { DetailsHeader } from '../../../components/load-details/LoadDetailsInlineEdit'
import { MarketplaceEquipmentDetails } from './MarketplaceEquipmentDetails'

interface IMarketplaceLoadDetailsSectionProps {
  shipmentDetails?: IShipment
}

export const MarketplaceLoadDetailsSection = memo<IMarketplaceLoadDetailsSectionProps>(
  ({ shipmentDetails }) => {
    const { equipment, info } = shipmentDetails || {}
    const { totalMiles } = info || {}
    return (
      <Card className='mt4 mb4'>
        <DetailsHeader />
        <InlineRow
          bodyClass='mt1'
          rowTitle='Miles'
          rowBody={
            <div className='body'>
              {totalMiles ? `${parseInt(totalMiles, 10)} miles` : DISPLAY.empty}
            </div>
          }
        />
        <InlineRow
          bodyClass='mt1'
          rowTitle='Equipment'
          rowBody={<MarketplaceEquipmentDetails equipment={equipment} />}
        />
      </Card>
    )
  }
)
